<template>
    <DModal
        :title="__('customers.customers.edit_with_invalid_data')"
        :message="__('customers.customers.edit_with_invalid_data_message', {customerData: customerData})"
        is-confirm
        is-error
        :show="showModal"
        @confirm="$emit('confirm-modal')"
        @close="$emit('close-modal')"
    />
</template>

<script>
export default {
    name: 'EditWithInvalidDataModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        invalidFields: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['confirm-modal', 'close-modal'],
    computed: {
        customerData () {
            return this.invalidFields.join(', ')
        }
    }
}
</script>

<style scoped>

</style>
